import React from 'react'
import { Tabs } from 'react-bootstrap'
import { useOutletContext, useSearchParams } from 'react-router-dom'
import type { TabsProps } from 'react-bootstrap/Tabs'

export type TabWithSearchParamsProps = {
  children?: any
  tabName?: string
  defaultActiveKey?: string
  sticky?: boolean
} & TabsProps

export const TabWithSearchParams = ({
  children,
  defaultActiveKey,
  tabName,
  sticky = false,
  ...props
}: TabWithSearchParamsProps) => {
  const [searchParams, setSearchParams] = useSearchParams()
  tabName = tabName ?? 'tab'

  const outletContext = useOutletContext<any>()
  const top = outletContext?.fromOffCanvas ? 40 : 100 //100 and 40 are commone

  const stickyClassName = sticky ? 'sticky-top' : ''
  const stickyStyle: React.CSSProperties = sticky
    ? {
        top: top,
        zIndex: 3,
        backgroundColor: 'var(--bs-body-bg)',
      }
    : {}

  return (
    <Tabs
      {...props}
      className={`${props.className || ''} ${stickyClassName}`.trim()}
      style={{ ...props.style, ...stickyStyle }}
      activeKey={searchParams.get(tabName) ?? defaultActiveKey}
      onSelect={(k) =>
        setSearchParams((searchParams) => {
          searchParams.set(tabName, k)
          return searchParams
        })
      }
      defaultActiveKey={defaultActiveKey}
    >
      {children}
    </Tabs>
  )
}
